import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import hospitalReducer from './hospitalSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    hospital: hospitalReducer,
  },
});
